import { mergeStyles, Stack, getTheme, Text } from 'office-ui-fabric-react';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ErrorOverlay = props => {
  var _props$styles;
  const styles = {
    root: {
      fontSize: 14,
      fontWeight: 400,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      position: 'absolute'
    }
  };
  const finalStyles = mergeStyles(styles.root, (_props$styles = props.styles) === null || _props$styles === void 0 ? void 0 : _props$styles.root);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.children, !props.isHidden && /*#__PURE__*/_jsx(Stack, {
      className: finalStyles,
      children: props.content ? props.content() : /*#__PURE__*/_jsx(Stack, {
        styles: {
          root: {
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            height: '100%',
            textAlign: 'center'
          }
        },
        children: /*#__PURE__*/_jsxs(Text, {
          children: ["The data did not load properly, please \xA0", /*#__PURE__*/_jsx(Text, {
            onClick: () => window.location.reload(),
            styles: {
              root: {
                cursor: 'pointer',
                color: getTheme().palette.themePrimary
              }
            },
            children: "refresh the page"
          })]
        })
      })
    })]
  });
};